import { render, staticRenderFns } from "./schedule.vue?vue&type=template&id=80d20d2a&scoped=true"
import script from "./schedule.vue?vue&type=script&lang=js"
export * from "./schedule.vue?vue&type=script&lang=js"
import style0 from "./schedule.vue?vue&type=style&index=0&id=80d20d2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d20d2a",
  null
  
)

export default component.exports